import React, { useEffect, useState } from 'react';

// Mascottes grimaces pour le carousel
const GRIMACE_MASCOTS = [
  'https://customer-assets.emergentagent.com/job_ab29e3e2-bd7d-4c51-9c4e-9dd332df0705/artifacts/g9kadylm_image.png',  // Contente
  'https://customer-assets.emergentagent.com/job_ab29e3e2-bd7d-4c51-9c4e-9dd332df0705/artifacts/elxpd42u_image.png',  // Pointe le doigt
  'https://customer-assets.emergentagent.com/job_ab29e3e2-bd7d-4c51-9c4e-9dd332df0705/artifacts/kboker7j_image.png',  // Se gratte la tête
  'https://customer-assets.emergentagent.com/job_ab29e3e2-bd7d-4c51-9c4e-9dd332df0705/artifacts/96wgv2ew_image.png',  // Enthousiaste
  'https://customer-assets.emergentagent.com/job_ab29e3e2-bd7d-4c51-9c4e-9dd332df0705/artifacts/lqvzknd0_image.png',  // Clin d'œil
];

// Faits éducatifs (peuvent être enrichis par API)
const DEFAULT_FACTS = [
  "Les éléphants sont les seuls animaux qui ne peuvent pas sauter !",
  "Une journée sur Vénus est plus longue qu'une année sur Vénus.",
  "Les pieuvres ont trois cœurs et du sang bleu !",
  "Les abeilles peuvent reconnaître les visages humains.",
  "La Lune s'éloigne de la Terre de 3,8 cm chaque année.",
  "Les dauphins dorment avec un œil ouvert.",
  "Le cœur d'une crevette est dans sa tête !",
  "Les flamants roses naissent blancs ou gris.",
  "Un nuage peut peser plus d'un million de kilos !",
  "Les koalas ont des empreintes digitales uniques comme les humains.",
];

const LoadingStoryModal = ({ 
  isVisible, 
  progress = 0, 
  currentStep = "Génération en cours...",
  storiesUsed = 0,
  storiesMax = 10,
  bonusStories = 0,
  storiesRemaining = 1
}) => {
  const [currentFactIndex, setCurrentFactIndex] = useState(0);
  const [pulseOpacity, setPulseOpacity] = useState(0.3);

  // Carousel auto-scroll des faits
  useEffect(() => {
    if (!isVisible) {
      setCurrentFactIndex(0);
      return;
    }

    const interval = setInterval(() => {
      setCurrentFactIndex(prev => (prev + 1) % DEFAULT_FACTS.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [isVisible]);

  // Animation pulse sur la partie non remplie
  useEffect(() => {
    if (!isVisible) {
      setPulseOpacity(0.3);
      return;
    }

    let increasing = true;
    const interval = setInterval(() => {
      setPulseOpacity(prev => {
        if (prev >= 0.7) increasing = false;
        if (prev <= 0.3) increasing = true;
        return increasing ? prev + 0.05 : prev - 0.05;
      });
    }, 80);

    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  const totalAvailable = storiesRemaining + bonusStories;

  return (
    <div 
      className="fixed inset-0 z-50 overflow-y-auto"
      style={{ backgroundColor: 'rgba(180, 210, 200, 0.97)' }}
    >
      <div className="min-h-screen px-4 py-8">
        {/* Compteurs en haut */}
        <div className="flex justify-center gap-2 mb-8">
          {/* Compteur histoires utilisées */}
          <div 
            className="flex-1 max-w-[100px] bg-white/90 rounded-2xl py-4 px-3 text-center"
            style={{ border: '1px solid rgba(224, 224, 224, 0.5)' }}
          >
            <div className="text-2xl mb-1">📖</div>
            <div className="text-lg font-bold text-gray-800">{storiesUsed}/{storiesMax}</div>
            <div className="text-xs text-gray-500">/mois</div>
          </div>

          {/* Compteur bonus */}
          <div 
            className="flex-1 max-w-[100px] bg-white/90 rounded-2xl py-4 px-3 text-center"
            style={{ border: '1px solid rgba(224, 224, 224, 0.5)' }}
          >
            <div className="text-2xl mb-1">🎁</div>
            <div className="text-lg font-bold text-gray-800">{bonusStories}</div>
            <div className="text-xs text-gray-500">bonus</div>
          </div>

          {/* Compteur disponible - highlighted */}
          <div 
            className="flex-1 max-w-[100px] bg-white/90 rounded-2xl py-4 px-3 text-center"
            style={{ border: '2px solid #4A90A4' }}
          >
            <div className="text-2xl mb-1">✨</div>
            <div className="text-lg font-bold" style={{ color: '#4A90A4' }}>{totalAvailable}</div>
            <div className="text-xs text-gray-500">dispo</div>
          </div>
        </div>

        {/* Carte "Le saviez-vous ?" */}
        <div 
          className="bg-white/95 rounded-3xl p-6 mx-auto max-w-md mb-8"
          style={{ minHeight: '240px' }}
        >
          {/* Mascotte */}
          <div className="flex justify-center mb-4">
            <img 
              src={GRIMACE_MASCOTS[currentFactIndex % GRIMACE_MASCOTS.length]}
              alt="Mascotte"
              className="w-20 h-24 object-contain"
              style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))' }}
            />
          </div>

          {/* Titre */}
          <h3 
            className="text-2xl font-bold text-center mb-3"
            style={{ fontFamily: '"Caveat", cursive', color: '#333333' }}
          >
            Le saviez-vous ?
          </h3>

          {/* Fait */}
          <p 
            className="text-center text-gray-600 leading-relaxed"
            style={{ fontSize: '15px' }}
          >
            {DEFAULT_FACTS[currentFactIndex]}
          </p>

          {/* Dots indicator */}
          <div className="flex justify-center gap-2 mt-4">
            {DEFAULT_FACTS.slice(0, 5).map((_, idx) => (
              <div 
                key={idx}
                className="w-2 h-2 rounded-full transition-all duration-300"
                style={{ 
                  backgroundColor: idx === (currentFactIndex % 5) 
                    ? '#4A90A4' 
                    : 'rgba(74, 144, 164, 0.3)'
                }}
              />
            ))}
          </div>
        </div>

        {/* Section progression */}
        <div className="max-w-md mx-auto">
          {/* Ligne de progression */}
          <div className="flex items-center mb-2">
            <span className="text-lg mr-2">🚀</span>
            <span className="flex-1 text-sm text-gray-800">{currentStep}</span>
            <span className="text-sm font-bold" style={{ color: '#4A90A4' }}>{Math.round(progress)}%</span>
          </div>

          {/* Barre de progression */}
          <div 
            className="h-[10px] rounded-full overflow-hidden relative"
            style={{ backgroundColor: '#E8E8E8' }}
          >
            {/* Partie remplie */}
            <div 
              className="absolute left-0 top-0 h-full rounded-full transition-all duration-300"
              style={{ 
                width: `${progress}%`,
                background: 'linear-gradient(90deg, #4A90A4 0%, #5BBFBD 100%)'
              }}
            />
            {/* Partie non remplie avec pulse */}
            <div 
              className="absolute top-0 h-full rounded-full"
              style={{ 
                left: `${progress}%`,
                right: 0,
                backgroundColor: `rgba(74, 144, 164, ${pulseOpacity})`
              }}
            />
          </div>

          {/* Temps estimé */}
          <p className="text-center text-sm text-gray-500 mt-3">
            Cela peut prendre 1-2 minutes
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingStoryModal;
